import { getType } from 'typesafe-actions';
import { setCurrentCountry } from '../actions/currentCountry.actions';

import { RootAction } from '../actions/types';
import { CurrentCountryState } from "./types";
import { COUNTRY_US } from '../../constants';

const initialState: CurrentCountryState = COUNTRY_US;

export default (state: CurrentCountryState = initialState, action: RootAction): CurrentCountryState => {
  switch (action.type) {
    case getType(setCurrentCountry): {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};